import React, { useEffect, useState } from "react";
import Popover from "theme/Popover";
import Card from 'theme/Card'
import Input from 'theme/Input';
import Text from 'theme/Text';
import Button from "theme/Button";
import { StyleSheet, View } from 'react-native'
import ThemedTimePicker from 'components/atoms/ThemedTimePicker'
import _ from 'lodash';
import ThemedSelect from 'components/atoms/ThemedSelect'
import { timeslotConstants } from 'utils/constants/timeslot-constants'
import i18n from 'utils/i18n'
import { ThemedValues, ThemedShared } from 'styles/themed'
import { colorList } from 'utils/colors'
import { Column, Container, Grid, Row } from 'components/atoms/BootstrapGrid'
import { createTranslationField } from 'utils/form-translations'
import Translate from 'utils/translate'
import { dataConstants } from 'services/redux/data/constants'
import { useSelector } from 'react-redux'
import ObjectTimeslot from 'utils/objects/timeslot'
import HelperString from 'utils/helper-string'
import FormRow from 'components/organisms/form/FormRow'
import { useLazyEffect } from 'utils/helper-react'
import LoadingComponent from 'components/atoms/Loading'
import { bookingConstants } from 'utils/constants/booking-constants'
import { roomConstants } from 'utils/constants/room-constants'
import { managementConstants } from 'services/redux/management/constants'
import { timeslotKindConstants, timeslotSubKindConstants } from 'utils/constants/timeslot-kind-constants'
import Timeslot from 'components/molecules/Timeslot'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import HelperDate from 'utils/helper-date'
import VStack from 'components/atoms/stack/VStack'
import ThemedSelectMulti from "components/atoms/ThemedSelectMulti";

const TimeslotCreate = ({ FormComponent, name, value = {}, exists = false, onChange, onRemove, itemKind, itemMode, disableKindBooking = false }) => {
	const _timeslotKinds = useSelector(state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	const _formTimeslot = useSelector( state => {
		return state.management[managementConstants.SELECTED_TIMESLOTS]?.formValues[name];
	} )
	
	const [ loading, setLoading ] = useState( true )
	
	const [ initialTranslations, setInitialTranslations ] = useState( {} );
	
	const [ borderColor, setBorderColor ] = useState( colorList.GREY.primary );
	
	const [ selectedTimeslotKind, setSelectedTimeslotKind ] = useState( null );
	const [ selectedTranslations, setSelectedTranslations ] = useState( {} );
	const [ selectedKind, setSelectedKind ] = useState( null )
	const [ selectedDays, setSelectedDays ] = useState( {} )
	const [ selectedTimeStart, setSelectedTimeStart ] = useState( null )
	const [ selectedTimeEnd, setSelectedTimeEnd ] = useState( null )
	const [ selectedCapacity, setSelectedCapacity ] = useState( null )
	
	const timePickerInterval = 5; // In minutes
	
	const onChangeTranslation = ( values ) => {
		setSelectedTranslations({
			...values
		})
	}
	
	const getValue = ( propsValue, defaultValue = null ) => {
		return _.get( _formTimeslot, propsValue, _.get( value, propsValue, defaultValue ) )
	}
	
	const onSelectDay = ( days ) => {
		const selectedDays = {};
		_.forEach( days, day => {
			selectedDays[ day ] = true;
		})
		
		setSelectedDays( selectedDays )
	}
	
	const onChangeCapacity = ( value ) => {
		value = value.replace( /[^0-9]/g, '' );
		
		setSelectedCapacity( _.isEmpty( value ) ? null : parseInt( value ) )
	}
	
	const submit = () => {
		if( _.isFunction( onChange ) ) {
			const kind = selectedKind.split('|')[0];
			const subKind = selectedKind.split('|')[1];
			
			const data = {
				capacity: selectedCapacity,
				kind: kind,
				sub_kind: subKind,
				timeslot_end: selectedTimeEnd,
				timeslot_start: selectedTimeStart,
				translations: selectedTranslations,
				timeslots: []
			};
			
			_.forEach( selectedDays, ( selected, day ) => {
				day = parseInt( day );
				
				if( selected ) {
					// Find the guid
					// Tweak this?
					let existing = _.find( ObjectTimeslot.parse( value ), {
						timeslot_day: day,
						kind: kind,
						sub_kind: subKind,
					});
					
					if( existing === undefined ) {
						existing = {
							timeslot_day: day,
							kind: kind,
							sub_kind: subKind,
						};
					}
					
					data.timeslots.push( existing );
				}
			});
			
			onChange( data );
		}
	}
	
	const onChangeSelectedFields = _.debounce( submit, 100 )
	
	// When a value changes
	useLazyEffect( onChangeSelectedFields, [ selectedKind, selectedDays, selectedTimeStart, selectedTimeEnd, selectedCapacity, selectedTranslations ] )
	
	//
	useEffect( () => {
		let days = {};
		_.map( ObjectTimeslot.parse( value ), timeslot => {
			days[ timeslot.timeslot_day ] = true;
			
			if( _.isEmpty( selectedTranslations ) ) {
				setInitialTranslations( timeslot.translations )
				
				// Set the correct values
				let values = {}
				_.forEach( timeslot.translations, trans => {
					const { name: transName } = createTranslationField( trans.field, trans.language )
					
					values[ transName ] = trans[ trans.field ]
				})
				
				setSelectedTranslations( values )
			}
		})
		
		if( _.isEmpty( days ) ) {
			_.forEach( getValue( 'timeslots', [] ), timeslot => {
				days[ timeslot.timeslot_day ] = true;
			})
		}
		
		setSelectedKind( `${getValue( 'kind', timeslotKindConstants.BOOKING ) }|${getValue( 'sub_kind', timeslotSubKindConstants.BOOKING ) }` );
		setSelectedTimeStart( getValue( 'timeslot_start', '00:00:00' ) )
		setSelectedTimeEnd( getValue( 'timeslot_end', '00:00:00' ) )
		setSelectedCapacity( getValue( 'capacity', null ) )
		
		setSelectedDays( days )
		setLoading( false )
	}, [] )
	
	useEffect( () => {
		if( selectedKind === null ){
			return;
		}
		
		let kind = selectedKind.split( '|' )[0];
		let sub_kind = selectedKind.split( '|' )[1];
		
		_.forEach( _timeslotKinds, ( _timeslotKind ) => {
			if( _timeslotKind.kind === kind && _timeslotKind.sub_kind === sub_kind ) {
				setSelectedTimeslotKind( _timeslotKind );
				return false;
			}
		});
		
	}, [ selectedKind ] );
	
	const days = _.map( _.range( 1, 8 ), day => {
		return (
			{
				key: day,
				value: HelperDate.date().day( day ).format('dddd')
			}
		);
	});
	
	const kindOptions = [];
	_.forEach( _timeslotKinds, ( _timeslotKind ) => {
		switch( itemMode ) {
			case bookingConstants.ROOM:
				if( itemKind === roomConstants.KIND_MEETING_ROOM && _timeslotKind.kind !== timeslotConstants.KIND_MEETING_ROOM ) {
					return true;
				}
				if( itemKind !== roomConstants.KIND_MEETING_ROOM && _timeslotKind.kind === timeslotConstants.KIND_MEETING_ROOM ) {
					return true;
				}
				break;
				
			default:
				if( _timeslotKind.kind === timeslotConstants.KIND_BOOKING && disableKindBooking ) {
					return true;
				}
				if( itemKind !== roomConstants.KIND_MEETING_ROOM && _timeslotKind.kind === timeslotConstants.KIND_MEETING_ROOM ) {
					return true;
				}
		}
		
		kindOptions.push( {
			value: `${_timeslotKind.kind}|${_timeslotKind.sub_kind}`,
			label: _timeslotKind.name
		});
	});
	
	//
	const formValues = {};
	const formFields = [];
	if( _.size( _languages ) > 0 ) {
		// Add the translation fields
		_.map( _languages, ( language ) => {
			_.map( { description: 'description' }, ( field, formName ) => {
				const { name, formField } = createTranslationField( formName, language );
				
				formFields.push( formField );
				
				const translation = Translate.formField( { translations: initialTranslations }, field, language );
				if( translation !== null ) {
					formValues[ name ] = translation;
				}
			})
		});
	}
	
	let content = <LoadingComponent />;
	
	let fakeBooking = null;
	
	if( selectedTimeslotKind !== null ){
		let fakeTranslations = [...selectedTimeslotKind.translations];
		
		_.forEach( selectedTranslations, ( selectedTranslation, selectedTranslationKey ) => {
			const [ identifier, field ] = selectedTranslationKey.split( ']' );
			const language_code = identifier.split( '|' )[ 1 ];
			
			if( _.get( fakeTranslations, language_code, null ) === null ){
				fakeTranslations[ language_code ] = {};
			}
			const translationField = field === 'description' ? 'description' : 'title';
			
			if( !_.isEmpty( selectedTranslation ) )
			{
				fakeTranslations.unshift( {
					field: field,
					[ translationField ]: selectedTranslation,
					language: { code: language_code }
				} );
			}
			
		});
		
		fakeBooking = {
			timeslot: {
				...selectedTimeslotKind,
				...{
					translations: fakeTranslations,
					timeslot_start: selectedTimeStart,
					timeslot_end: selectedTimeEnd,
					capacity: selectedCapacity
				}
			}
		};
	}
	
	if( !loading ) {
		
		content = (
			<View
				style={ [
					styles.container,
					{
						borderLeftWidth: 4,
						borderColor: borderColor
					}
				] }>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					{ fakeBooking !== null && (
						<ThemedBlock shadow>
							<Timeslot item={ fakeBooking } itemProps={ { showCapacity: true } } timeslotKind={ selectedTimeslotKind } timeslotIconOverWriteProperties={ selectedTimeslotKind }/>
						</ThemedBlock>
					)}
					
					<Grid>
						<Container>
							<Row space={ 2 }>
								<Column>
									<FormRow
										title={ i18n.t('management:form.kind.title') }>
										
										<ThemedSelect
											key={ HelperString.hash( 'timeslot', 'select-kind') }
											placeholder={ null }
											disabled={ exists }
											options={ kindOptions }
											select={ setSelectedKind.bind( this ) }
											selected={ selectedKind }
											style={ styles.select }
										/>
									</FormRow>
								</Column>
								<Column>
									<FormRow
										title={ i18n.t('management:form.time_start.title') }>
										
										<ThemedTimePicker
											key={ HelperString.hash('timeslot', 'select-time-start') }
											time={ selectedTimeStart }
											minuteInterval={ timePickerInterval }
											max={ selectedTimeEnd === '00:00:00' ? null : selectedTimeEnd }
											onSelect={ setSelectedTimeStart.bind( this ) }
											style={ styles.select }
										/>
									</FormRow>
								</Column>
								<Column>
									<FormRow
										title={ i18n.t('management:form.time_end.title') }>
									
										<ThemedTimePicker
											key={ HelperString.hash('timeslot', 'select-time-end') }
											time={ selectedTimeEnd }
											minuteInterval={ timePickerInterval }
											min={ selectedTimeStart === '00:00:00' ? null : selectedTimeStart }
											onSelect={ setSelectedTimeEnd.bind( this ) }
											style={ styles.select }
										/>
									</FormRow>
								</Column>
							</Row>
							
							<Row>
								<Column>
									<FormRow
										title={ i18n.t('management:form.days.title') }>
										
										<ThemedSelectMulti
											key={ HelperString.hash( 'timeslot', 'select-day') }
											placeholder={ null }
											options={ _.map( days, (day) => {
												return {
													value: day.key,
													label: day.value
												}
											})}
											select={ onSelectDay.bind( this ) }
											selected={ _.map( _.keys( selectedDays ), day => {
												return parseInt(day);
											} ) }
										/>
									</FormRow>
								</Column>
							</Row>
							
							{_.size( formFields ) > 0 && (
								<Row>
									<Column>
										<FormRow
											title={ '' }>
											
											<FormComponent
												key={ HelperString.hash( 'form', 'translations' ) }
												values={ formValues }
												fields={ formFields }
												onlyFields={ true }
												onChange={ onChangeTranslation.bind( this ) }
											/>
										</FormRow>
									</Column>
								</Row>
							)}
							
							<Row justify={'space-between'}>
								<Column auto>
									<FormRow
										title={ i18n.t('management:form.capacity.title') }>
										
										<Input
											defaultValue={ _.toString( selectedCapacity ?? 0 ) }
											blurOnSubmit={ false }
											onChangeText={ onChangeCapacity.bind( this ) }
										/>
									</FormRow>
								</Column>
								
								<Column auto>
									<PopoverRemove
										onRemove={ onRemove }
									/>
								</Column>
							</Row>
						</Container>
					</Grid>
				</VStack>
			</View>
		)
	}
	
	return content;
}

const PopoverRemove = ({ onRemove }) => {
	
	const [ modalVisible, setModalVisible ] = useState( false )
	
	const onPressRemove = () => {
		onRemove();
		
		setModalVisible( false )
	}
	
	if( !_.isFunction( onRemove ) ) {
		return null;
	}
	
	return (
		<FormRow
			title={ ' ' }>
			
			<Popover
				anchor={ () => {
					return (
						<Button
							style={ styles.buttonRight }
							appearance={ 'ghost' }
							size="small"
							onPress={ setModalVisible.bind( this, true ) }
							accessoryLeft={ props => {
								return (
									<Icon icon={ IconSystemConstants.TRASH }
										{ ...props }
										size={ 12 }
										style={ [ props?.style, styles.iconColorPrimary ] }
									/>
								);
							}}>

							{ i18n.t('management:generic.remove') }
						</Button>
					);
				}}
				visible={ modalVisible }
				onBackdropPress={ setModalVisible.bind( this, false ) }>
				
				<Card>
					<Text
						style={ ThemedShared.paddingSmall }>
						
						{ i18n.t('management:generic.timeslot.remove.title') }
					</Text>
					<Button
						onPress={ onPressRemove.bind( this ) }>
						
						{ i18n.t('management:generic.timeslot.remove.button') }
					</Button>
				</Card>
			</Popover>
		</FormRow>
	)
}

const styles = StyleSheet.create({
	iconColorPrimary: {
		color: colorList.PRIMARY.primary,
	},
	container: {
		flex: 1,
		flexDirection: 'column',
		width: '100%',
		padding: ThemedShared.paddingSmall.padding,
		borderRadius: ThemedValues.borderRadius,
		backgroundColor: colorList.GREY.light
	},
	
	select: {
		flex: 1
	},
	
	buttonRight: {
		width: 'auto',
		justifyContent: 'flex-end',
		alignSelf: 'flex-end',
	},
});

export default TimeslotCreate
